import { createToast, Position, ToastType, TransitionType } from "mosha-vue-toastify";

export abstract class NotificationsService {
    private static readonly position: Position = 'bottom-right';
    private static readonly showCloseButton: boolean = true;
    private static readonly showIcon: boolean = true;
    private static readonly transition: TransitionType = "bounce";

    private static show( type: ToastType, title: string, msg: string, timeout = 5000 ) {
        createToast( { title: title, description: msg }, {
            type: type,
            position: this.position,
            showCloseButton: this.showCloseButton,
            showIcon: this.showIcon,
            transition: this.transition,
            timeout: timeout
        } );
    }

    public static success( title: string, msg: string, timeout = 5000 ) {
        this.show( "success", title, msg, timeout );
    }

    public static warning( title: string, msg: string, timeout = 5000 ) {
        this.show( "warning", title, msg, timeout );
    }

    public static error( title: string, msg: string, timeout = 5000 ) {
        this.show( "danger", title, msg, timeout );
    }

    public static info( title: string, msg: string, timeout = 5000 ) {
        this.show( "info", title, msg, timeout );
    }
}